import React from "react";
import { Box, Placeholder, Snackbar, Stack } from "@origin-digital/ods-core";
import { ResponsiveSpace } from "@origin-digital/ods-types/.";
import { DashboardProps } from "./types";
import { DashboardContextProvider } from "./DashboardContextProvider";
import { useDashboardContext } from "./context";

const DashboardContent = ({
  pageTitleSection = <Placeholder label="Page title" height="28px" />,
  actionSection = <Placeholder label="Actions" height="40px" />,
  children: contentSection,
  "data-id": dataId = "dashboard",
}: DashboardProps) => {
  const { snackbarSection } = useDashboardContext();
  return (
    <Box
      // These hardcoded values may throw TS errors - for demo purposes only.
      // Solution to be left up the the developer
      marginTop={
        {
          xs: "32px",
          lg: "56px",
        } as unknown as ResponsiveSpace
      }
      marginX={"auto" as unknown as ResponsiveSpace}
      paddingX={["medium", "large"]}
      style={{ maxWidth: "1440px", zIndex: "20", top: "0" }}
      width="full"
      data-id={`${dataId}.rootContainer`}
    >
      {/* Inner container */}
      <Stack space={["small", "medium"]}>
        {/* Page title + Actions */}
        <Box display="flex" flexDirection="column" gap={["large", "xlarge"]}>
          {/* Page title */}
          <Box data-id={`${dataId}.pageTitleSection`} data-role="section">
            {pageTitleSection}
          </Box>
          {/* End Page title */}

          {/* Actions */}
          <Box data-id={`${dataId}.actionSection`} data-role="section">
            {actionSection}
          </Box>
          {/* End Actions */}
        </Box>
        {/* End Page title + Actions */}
        {/* Requests + projects views */}
        <Box
          marginBottom="xlarge"
          data-id={`${dataId}.contentSection`}
          data-role="section"
        >
          {contentSection}
        </Box>
        {/* End Requests + projects views */}
      </Stack>
      {/* End Inner container */}
      {snackbarSection && snackbarSection.props && (
        <Snackbar
          data-id={`${dataId}.snackbar`}
          align="left"
          {...snackbarSection.props}
        />
      )}
    </Box>
  );
};

export const Dashboard: React.FC<DashboardProps> = (dashboardProps) => {
  return (
    <DashboardContextProvider>
      <DashboardContent {...dashboardProps} />
    </DashboardContextProvider>
  );
};
